import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const categoryLabels: Record<string, string> = {
  'ru-men-jiao-cheng': '入门教程',
  'yan-zou-ji-qiao': '演奏技巧',
  'xuan-gou-zhi-nan': '选购指南',
  'pin-pai-dui-bi': '品牌对比',
  'li-shi-qi-yuan': '历史起源',
  'wei-hu-bao-yang': '维护保养',
};

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20hexagonal%20traditional%20Chinese%20string%20instrument%20liujiaoqin%20displayed%20on%20a%20warm%20wooden%20stand%20with%20soft%20natural%20lighting%20minimalist%20studio%20setting%20with%20cream%20background%20elegant%20educational&width=600&height=400&seq=cat-art-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20holding%20bamboo%20mallets%20over%20hexagonal%20string%20instrument%20demonstrating%20grip%20technique%20soft%20natural%20light%20warm%20cream%20background%20educational&width=600&height=400&seq=cat-art-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Student%20at%20hexagonal%20instrument%20with%20sheet%20music%20and%20metronome%20warm%20afternoon%20light%20cozy%20home%20practice%20setting%20cream%20walls%20natural%20photography&width=600&height=400&seq=cat-art-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Young%20child%20at%20small%20hexagonal%20instrument%20with%20smiling%20parent%20bright%20home%20environment%20soft%20diffused%20lighting%20cream%20wood%20tones%20heartwarming&width=600&height=400&seq=cat-art-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Professional%20musician%20hands%20playing%20hexagonal%20instrument%20dynamic%20action%20shot%20dramatic%20side%20lighting%20dark%20warm%20background%20artistic%20performance&width=600&height=400&seq=cat-art-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Array%20of%20different%20mallets%20beaters%20beside%20hexagonal%20instrument%20various%20materials%20warm%20studio%20lighting%20shallow%20depth%20professional%20equipment&width=600&height=400&seq=cat-art-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20with%20sheet%20music%20on%20stand%20traditional%20Chinese%20notation%20warm%20desk%20lamp%20intimate%20practice%20room%20cream%20walls%20cultural%20artistic&width=600&height=400&seq=cat-art-7&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Musical%20theory%20diagram%20overlaying%20softly%20lit%20hexagonal%20instrument%20creative%20double%20exposure%20warm%20amber%20cream%20tones%20artistic%20educational&width=600&height=400&seq=cat-art-8&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=Multiple%20hexagonal%20instruments%20different%20sizes%20wood%20finishes%20on%20warm%20wooden%20rack%20well-lit%20instrument%20shop%20soft%20natural%20lighting%20cream%20walls%20elegant%20retail&width=600&height=400&seq=cat-art-9&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Entry-level%20hexagonal%20instrument%20with%20price%20tag%20clean%20white%20background%20music%20store%20natural%20wood%20finish%20bright%20airy%20commercial%20photography&width=600&height=400&seq=cat-art-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Premium%20handcrafted%20hexagonal%20instrument%20exquisite%20wood%20grain%20detailed%20craftsmanship%20golden%20warm%20lighting%20professional%20studio%20dark%20background%20luxury%20product&width=600&height=400&seq=cat-art-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Pre-owned%20hexagonal%20instrument%20with%20well-maintained%20patina%20showing%20character%20cozy%20vintage%20music%20room%20warm%20natural%20light%20authentic%20atmospheric&width=600&height=400&seq=cat-art-12&orientation=landscape',
  13: 'https://readdy.ai/api/search-image?query=Collection%20of%20ten%20hexagonal%20instruments%20various%20brands%20gallery-style%20display%20professional%20lighting%20museum-quality%20cream%20background%20comprehensive%20comparison&width=600&height=400&seq=cat-art-13&orientation=landscape',
  14: 'https://readdy.ai/api/search-image?query=Two%20hexagonal%20instruments%20side%20by%20side%20classic%20traditional%20finish%20modern%20design%20studio%20comparison%20neutral%20lighting%20clean%20composition&width=600&height=400&seq=cat-art-14&orientation=landscape',
  15: 'https://readdy.ai/api/search-image?query=Master%20craftsman%20hands%20working%20on%20hexagonal%20instrument%20traditional%20workshop%20wood%20shavings%20tools%20warm%20golden%20light%20artisanal%20craftsmanship%20rich%20textures&width=600&height=400&seq=cat-art-15&orientation=landscape',
  16: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20Chinese%20and%20international%20design%20influences%20world%20map%20background%20global%20fusion%20warm%20professional%20lighting%20sophisticated%20product&width=600&height=400&seq=cat-art-16&orientation=landscape',
  17: 'https://readdy.ai/api/search-image?query=Antique%20hexagonal%20instrument%20Ming-Qing%20dynasty%20museum%20display%20aged%20wood%20historical%20patina%20soft%20museum%20lighting%20cultural%20heritage%20scholarly%20elegant&width=600&height=400&seq=cat-art-17&orientation=landscape',
  18: 'https://readdy.ai/api/search-image?query=Elderly%20master%20musician%20performing%20hexagonal%20instrument%20traditional%20Chinese%20attire%20warm%20stage%20lighting%20heritage%20tradition%20respectful%20dignified&width=600&height=400&seq=cat-art-18&orientation=landscape',
  19: 'https://readdy.ai/api/search-image?query=Inside%20traditional%20instrument%20workshop%20craftsman%20hands%20carving%20wood%20hexagonal%20instrument%20woodworking%20tools%20warm%20workshop%20lighting%20artisanal%20documentary&width=600&height=400&seq=cat-art-19&orientation=landscape',
  20: 'https://readdy.ai/api/search-image?query=Portrait%20distinguished%20Chinese%20musician%20hexagonal%20instrument%20black%20white%20vintage%20warm%20sepia%20tones%20historical%20documentary%20cultural%20legacy&width=600&height=400&seq=cat-art-20&orientation=landscape',
  21: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20being%20carefully%20cleaned%20with%20soft%20cloth%20caring%20hands%20close-up%20bright%20clean%20studio%20lighting%20maintenance%20care%20fresh%20pristine&width=600&height=400&seq=cat-art-21&orientation=landscape',
  22: 'https://readdy.ai/api/search-image?query=Digital%20tuner%20clipped%20onto%20hexagonal%20instrument%20display%20showing%20perfectly%20tuned%20note%20warm%20natural%20lighting%20educational%20demonstration%20clean%20precise&width=600&height=400&seq=cat-art-22&orientation=landscape',
  23: 'https://readdy.ai/api/search-image?query=Hands%20changing%20strings%20on%20hexagonal%20instrument%20new%20strings%20carefully%20installed%20tools%20on%20wooden%20workbench%20bright%20task%20lighting%20DIY%20maintenance%20practical&width=600&height=400&seq=cat-art-23&orientation=landscape',
  24: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20one%20section%20highlighted%20showing%20common%20issue%20area%20diagnostic%20photography%20clear%20educational%20warm%20workshop%20lighting%20problem-solving&width=600&height=400&seq=cat-art-24&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === slug);
  const otherCategories = categories.filter((c) => c.slug !== slug);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - 六角琴专业指南`,
          description: category.description,
          url: `https://www.liujiaoqin.com/category/${slug}`,
        }}
      />
      <Navbar />
      <main className="min-h-screen pt-16">
        <Breadcrumb />
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-md bg-primary-500 flex items-center justify-center">
                <i className={`${category.icon} text-xl md:text-2xl text-background-50 w-6 h-6 md:w-7 md:h-7 flex items-center justify-center`}></i>
              </div>
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="mt-1 text-sm text-foreground-500 max-w-xl">
                  {category.description}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-6">
                  共 {categoryArticles.length} 篇文章
                </h2>
                {categoryArticles.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
                    {categoryArticles.map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.slug}`}
                        className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                      >
                        <div className="h-44 md:h-48 w-full overflow-hidden">
                          <img
                            src={articleImages[article.id] || articleImages[1]}
                            alt={article.title}
                            title={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        </div>
                        <div className="p-4 md:p-5">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="text-xs text-foreground-400">{article.readTime}</span>
                            <span className="text-xs text-foreground-400">{article.date}</span>
                          </div>
                          <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                            {article.title}
                          </h3>
                          <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                            {article.excerpt}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <p className="text-foreground-500 text-sm">该分类暂无文章，敬请期待。</p>
                )}
              </div>

              <aside className="lg:w-72 flex-shrink-0">
                <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 sticky top-20">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-4">其他分类</h3>
                  <div className="space-y-1">
                    {otherCategories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-50 transition-colors whitespace-nowrap"
                      >
                        <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-foreground-400`}></i>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}